export const renderSuggestionAfter3Chars = value => value.trim().length > 2;

export const highlightSearchTerm = (suggestion, searchTerm) =>
  suggestion.replace(
    new RegExp(searchTerm, 'i'),
    `<span class='highlight'>${searchTerm}</span>`
  );

export const clean = value => value.replace(/[.\-(),!@#$%^*]/gi, '');
